<template>
    <el-dialog
        title="试卷修改"
        :visible.sync="editVisible"
        width="70%"
        :close-on-click-modal="false"
        @open="loadPaperDetails"
        @closed="clearEdit"
        custom-class="m-dialog"
        id="zjEditePaper"
        :lock-scroll="false">
        <div v-loading="flag.editLoading" element-loading-text="正在努力加载试题">
            <!-- 筛选项 -->
            <div class="e-condition xy-start flex-wrap">
                <div class="xy-center jf-start item">
                    <div class="name">试卷名称</div>
                    <el-input v-model="activePaper.ExamName"></el-input>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">所属分类</div>
                    <medical-class-selector
                        v-model="activePaper.ClassId"
                        :add-all="false"
                    ></medical-class-selector>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">用途</div>
                    <el-select
                        v-model="activePaper.ExamUse"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="item in useForData"
                            :key="item.value"
                            :value="item.value"
                            :label="item.name"
                        ></el-option>
                    </el-select>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">总分</div>
                    <el-input
                        v-model="activePaper.TotalScore"
                        disabled
                        type="number"
                    ></el-input>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">及格分</div>
                    <el-input
                        v-model.number="activePaper.PassScore"
                        type="number"
                        @input="
                                (vl) => {
                                    if (vl > activePaper.TotalScore) {
                                        $message.warning('超过了试卷总分');
                                    }
                                }
                            "
                    ></el-input>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">权限</div>

                    <el-select
                        v-model="activePaper.Authority"
                        placeholder="请选择"
                    >
                        <el-option :value="1" label="机构公开"></el-option>
                        <el-option :value="2" label="平台公开"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="e-paper xy-start al-str">
                <div class="que-type" :class="{ border: !typeList.length }">
                    <div class="add-new-type xy-center">
                        <el-button type="primary" @click="addNewType">新建题型</el-button>
                    </div>
                    <div class="added-tp" :key="keyIndex">
                        <type-box-mini
                            v-for="(box, index) in typeList"
                            :key="box._uuid"
                            :type-box-data="box"
                            @delete-type="deleteType(index)"
                            @change-pos="changePosition"
                            @click="scrollTo(index)"
                        ></type-box-mini>
                    </div>
                </div>
                <div
                    class="auto-grow"
                    :class="{ border: !typeList.length }">
                    <type-box
                        v-for="(box, index) in typeList"
                        :key="box._uuid"
                        :id="'type-box-' + index"
                        :box-data="box"
                        :paper-edit="true"
                        :default-class-id="activePaper.ClassId"
                        :default-use-type="activePaper.ExamUse"
                    ></type-box>
                </div>
            </div>
        </div>
        <span slot="footer" class="xy-center">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button
                    type="primary"
                    @click="updatePaper"
                    :disabled="!btnDisable"
                    :loading="flag.updateLoading">保存试卷</el-button
                >
            </span>
    </el-dialog>
</template>

<script>
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import TypeBox from "@/components/manager/resource/TypeBox.vue";
import TypeBoxMini from "@/components/manager/resource/TypeBoxMini.vue";
import {
    deletePaper,
    fetchPaperDetails,
    createPaper,
} from "@/api/manage";
import { CommonPage } from "@/mixins/commonData";
import { scrollTop } from "@/utils/scrollHelper";
import { PaperManagerHelper } from "@/mixins/paperManageHelper";
import { uuid } from "@/utils";
import { SubjectType } from "@/kernel";

export default {
    mixins: [CommonPage, PaperManagerHelper],
    components: {
        TypeBox,
        TypeBoxMini,
        MedicalClassSelector,
    },
    provide() {
        return {
            organClass: this.organClassProvide
        }
    },
    data() {
        return {
            paperInfo: {
                type: "",
                state: "",
                useFor: "",
                searchKey: "",
            },
            flag: {
                loading: false,
                editLoading: false,
                updateLoading: false,
            },
            editVisible: false,
            multipleSelection: [],
            totalCount: 0,
            currentPage: 1,
            pageSize: 10,
            tableData: [],
            activePaper: {},
            typeList: [],
            keyIndex: 0,
            organClassProvide: []
        };
    },
    computed: {
        btnDisable() {
            return Boolean(
                this.activePaper.ExamName &&
                this.activePaper.TotalScore &&
                this.activePaper.PassScore &&
                this.activePaper.ClassId
            );
        },
        organClass() {
            let data = this.$refs.select.categories.slice(1);
            let newData = [];
            const work = (vl, pIds) => {
                for (let i = 0; i < vl.length; i++) {
                    newData.push({
                        label: vl[i].ClassName,
                        value: vl[i].ClassId,
                        parentIds: pIds,
                    });
                    if (vl[i] && vl[i].children && vl[i].children.length) {
                        work(vl[i].children, pIds.concat([vl[i].ClassId]));
                    }
                }
            };
            if (data.length > 0) {
                work(data, []);
            }

            // console.log("newData:", newData);
            return newData || [];
        },
    },
    watch: {
        totalScore(score) {
            this.activePaper.TotalScore = score;
        },
        subjectNum(num) {
            this.activePaper.SubjectNum = num
        },
        paperInfo: {
            handler: function (vl) {
                if (vl.searchKey !== (this.searchKey || "")) {
                    this.searchKey = vl.searchKey;
                    return;
                }
            },
            deep: true,
            immediate: true,
        },
        typeList(list) {
            this.activePaper.SubjectTypeList = list
        }
    },
    methods: {
        handleEdit(index, row) {
            this.activePaper = {
                ExamPaperId: row.ExamPaperId,
            };
            this.editVisible = true;
            // console.log(index, row);
        },
        handleState(index, row) {
            const state = parseInt(row.ExamState);
            deletePaper({
                ids: row.ExamPaperId,
                state: !state ? 1 : 0,
            }).then((res) => {
                this.$message.success("已" + (!state ? "启用" : "禁用"));
            });
        },
        loadPaperDetails() {
            this.flagPromise(
                [fetchPaperDetails({ id: this.activePaper.ExamPaperId })],
                "editLoading"
            ).then(([res]) => {
                this.activePaper = res;
                this.typeList = this.activePaper.SubjectTypeList.map(el => {
                    el._uuid = uuid()
                    return el
                });
            });
        },
        open (ExamPaperId) {
            this.activePaper = {
                ExamPaperId,
            };
            this.editVisible = true;
        },
        close () {
            this.editVisible = false
        },
        addNewType() {
            this.typeList.push({
                RankNum: this.typeList.length + 1,
                Content: "新题型",
                SubScore: 0,
                TotalScore: 0,
                SubjectNum: "0",
                _uuid: uuid(),
                SubjectList: [
                    // {
                    //     SubjectType: 1,
                    //     Content: "我是试题题干",
                    //     Answer: "A",
                    //     AnswerList: [
                    //         { RankNum: 1, Content: "第一个选项", IsRight: 0 },
                    //         { RankNum: 2, Content: "第二个选项", IsRight: 0 },
                    //         { RankNum: 3, Content: "第三个选项", IsRight: 1 },
                    //     ],
                    //     Analysis: "解析可以没有",
                    //     Hardlevel: 1,
                    //     Score: "",
                    //     RankNum: 1,
                    // },
                    // {
                    //     SubjectType: 2,
                    //     Content: "我是试题题干",
                    //     Answer: ["C", "D"],
                    //     AnswerList: [
                    //         { RankNum: 1, Content: "第一个选项", IsRight: 0 },
                    //         { RankNum: 2, Content: "第二个选项", IsRight: 0 },
                    //         { RankNum: 3, Content: "第三个选项", IsRight: 1 },
                    //         { RankNum: 4, Content: "第四个选项", IsRight: 1 },
                    //     ],
                    //     Analysis: "解析可以没有",
                    //     Hardlevel: 2,
                    //     Score: "",
                    //     RankNum: 2,
                    // },
                    // {
                    //     SubjectType: 3,
                    //     Content: "填空题(),()试题题干",
                    //     Answer: "答案",
                    //     AnswerList: [
                    //         { RankNum: 1, Content: "第一个答案", IsRight: 1 },
                    //         { RankNum: 2, Content: "第二个答案", IsRight: 1 },
                    //     ],
                    //     Analysis: "解析可以没有",
                    //     Hardlevel: 2,
                    //     Score: "",
                    //     RankNum: 3,
                    // },
                    // {
                    //     SubjectType: 4,
                    //     Content: "判断题的正确显示",
                    //     Answer: "A",
                    //     AnswerList: [
                    //         { RankNum: 1, Content: "第一个选项", IsRight: 0 },
                    //         { RankNum: 2, Content: "第二个选项", IsRight: 1 },
                    //     ],
                    //     Analysis: "解析可以没有",
                    //     Hardlevel: 1,
                    //     Score: "",
                    //     RankNum: 4,
                    // },
                    // {
                    //     SubjectType: 5,
                    //     Content: "问答题题干...",
                    //     Answer: "问答题是最初试题类型",
                    //     AnswerList: [],
                    //     Analysis: "解析可以没有",
                    //     Hardlevel: 3,
                    //     Score: "",
                    //     RankNum: 5,
                    // },
                ],
            });
            this.$nextTick(() => {
                this.scrollTo(this.typeList.length - 1)
            })
        },
        deleteType(index) {
            this.typeList.splice(index, 1);
            this.resetSubjectTypeRank(this.typeList, false)
        },
        scrollTo(index) {
            let target = document.querySelector("#type-box-" + index)
            let container = document.querySelector("#zjEditePaper")
            scrollTop(container, target)
        },
        resetQuesRank(subjectList) {
            subjectList.forEach((q, index) => (q.RankNum = index + 1))
        },
        resetSubjectTypeRank(subjectTypeList, needRestQuestion = false) {
            subjectTypeList.forEach((res, typeRank) => {
                res.RankNum = typeRank + 1
                if (needRestQuestion) {
                    this.resetQuesRank(res.SubjectList)
                }
            });
        },
        updatePaper() {
            this.activePaper.SubjectTypeList = this.typeList;
            this.resetSubjectTypeRank(this.activePaper.SubjectTypeList, true)
            // console.log(" this.typeList:", this.typeList);
            let message = this.checkError(this.typeList);
            // console.log("message:", message);
            if (message) {
                this.$message.warning(message);
                return;
            }
            let copy = {
                ...this.activePaper,
            };

            // 不知道为什么这里要删除试题选项
            copy.SubjectTypeList.forEach((element) => {
                element.SubjectList.forEach((q, index) => {
                    q.RankNum = index + 1
                    if (q.SubjectType === 2 && Array.isArray(q.Answer)) {
                        q.Answer = q.Answer.join(",")
                    }
                    if (q.ClassId == null || q.ClassId === 0) {
                        q.ClassId = this.activePaper.ClassId
                    }
                    if (q.UseType == null || q.UseType === 0) {
                        q.UseType = this.activePaper.ExamUse
                    }
                    if (q.SubjectType === SubjectType.multiple && Array.isArray(q.Answer)) {
                        q.Answer = q.Answer.join("、")
                    }
                });
            });
            // console.log("copy:", copy);
            this.flagPromise(
                [
                    createPaper({
                        examPaperModel: JSON.stringify(copy),
                    }),
                ],
                "updateLoading"
            ).then(([res]) => {
                this.$message.success("已更新试卷");
                this.editVisible = false;
                this.$emit("updatePaper", res)
            });
            // console.log("activePaper:", this.activePaper);
        },
        checkError(typeList) {
            console.log("typeList:", typeList);
            let message;
            for (let i = 0; i < typeList.length; i++) {
                const item = typeList[i];
                if (!item.Content) {
                    message = "请输入模块名称";
                    break;
                }
                let hasQues = item.SubjectList && item.SubjectList.length > 0
                let hasRule = item.RandomSubjectList && item.RandomSubjectList.length > 0
                if (!hasQues && !hasRule) {
                    message = "请添加试题";
                    break;
                }
                if (hasQues) {
                    const isFill = item.SubjectList.every((q) => q.Score);
                    // console.log("isFill:", isFill);
                    if (!isFill) message = "请输入试题分数";
                }
                if (hasRule) {
                    const isFill = item.RandomSubjectList.every(q => q.SubScore)
                    if (!isFill) message = "请输入组卷试题分数";
                }
            }
            return message;
        },
        changePosition([ty, pos]) {
            const index = this.typeList.findIndex(
                (item) => item._uuid === ty._uuid
            );
            console.log("index:", index);

            if (pos === "behind") {
                console.log("向后");
                this.goBehind(ty, index);
            }
            if (pos === "ahead") {
                this.goAhead(ty, index);
                console.log("向前");
            }
        },
        goBehind(item, index) {
            const tIndex = index;

            if (tIndex === this.typeList.length - 1) {
                this.$message.warning("已经是最后一个试题模块了");
                return;
            }
            const lastPositionType = this.typeList[tIndex + 1];
            // console.log("lastPositionQ:", lastPositionQ);
            this.typeList[tIndex + 1] = {
                ...item,
                RankNum: tIndex + 2,
            };
            this.typeList[tIndex] = {
                ...lastPositionType,
                RankNum: tIndex + 1,
            };
            this.keyIndex += 1;
            this.typeList = Array.from(this.typeList)
            // console.log("typeList:", this.typeList);
        },
        goAhead(item, index) {
            const tIndex = index;
            if (tIndex === 0) {
                this.$message.warning("已经是第一个试题模块了");
                return;
            }
            const aheadPositionType = this.typeList[tIndex - 1];
            this.typeList[tIndex - 1] = {
                ...item,
                RankNum: tIndex,
            };
            this.typeList[tIndex] = {
                ...aheadPositionType,
                RankNum: tIndex + 1,
            };
            this.keyIndex += 1;
            this.typeList = Array.from(this.typeList)
            // console.log("typeList:", this.typeList);
        },
        /// 清理试卷编辑
        clearEdit() {
            this.activePaper = {}
            this.typeList = []
        },
        updateOrganClass(list) {
            this.organClassProvide.length = 0
            this.organClassProvide.push(...list)
        },
    },
};
</script>

<style lang="less" scoped>
.margin-left-xs {
    margin-left: 10px;
}
.e-condition {
    padding: 0 30px;
    .item {
        margin-top: 30px;
        margin-right: 10px;
        .name {
            white-space: nowrap;
            min-width: 5em;
            font-size: 16px;
            text-align: right;
            padding-right: 8px;
            text-align: right;
        }
    }
    .el-input {
        width: 210px;
        height: 34px;
        input {
            height: 34px;
            ::placeholder {
                font-size: 16px;
            }
        }
    }
}
.e-paper {
    margin: 60px 0 30px;
    padding: 0 30px;
    .que-type {
        flex-shrink: 0;
        width: 270px;
        margin-right: 10px;
        min-height: 200px;
        max-height: 85vh;
        border: 1px solid #e5e8ec;
        overflow-y: auto;
        position: sticky;
        top: 2.5vh;
        &::-webkit-scrollbar {
            width: 4px;
            background: #f4f5f6;;
        }
        &::-webkit-scrollbar-thumb {
            background: grey;
        }

        .add-new-type {
            height: 60px;
            background: #f4f5f6;
            position: sticky;
            top: 0;
            z-index: 5;
            .el-button {
                height: 36px;
                width: 120px;
                border-radius: 4px;
                padding: 0;
            }
        }
        .added-tp {
            padding: 20px 20px 0;
        }
    }
    .border {
        border: 1px solid #e5e8ec;
        min-height: 200px;
    }
}
</style>
